import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider, TextField, Grid, Typography, Box, CircularProgress } from "@mui/material"

import { getPmorderStruct, setData } from './PmorderStruct'
import { updateTextValue, handleSubmit, updateValue, updateSelectedValue } from '../../core/js/FormUtils'
import { createAPI, updateAPI, getAPI, updateEditableAPI } from './PmorderAPI';
import { CoreContext } from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validMobileNumberEntry, validNameEntry, validEmailEntry } from '../../core/js/FormValidation';

import { getPathVariable } from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch, useSelector } from 'react-redux';
import { updatePmorderObj, addPmorderObj, setShowEditForPmorder } from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import { getListAPI as getDesignVendorList } from 'components/designvendor/DesignvendorAPI';
import { setDesignvendorList } from 'store/slice/PharmaSlice';



export default function PmorderEditFormImpl() {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getPmorderStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const {rolename} = useSelector((state)=>state.headerslice.userprofileInfo);
    const {selectedTaskObj} = useSelector((state)=>state.appslice.wkflow);

    const { pmorderDashboard } = useSelector((state) => state.pharmaslice);
    const [pmorderId, setPmorderId] = useState(pmorderDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo);
    const [showUnitId, setShowUnitId] = useState(false);

    const { dmunitList } = useSelector((state) => state.pharmaslice);
    const handleDynamicSelectedValueForunitid = (e) => {
        updateSelectedValue(formValues, setFormValues, e,
            'unitname', e.target.value == 0 ? 'Select Item' : dmunitList.find(obj => obj.id === e.target.value).title);
    }

    const {designvendorList} = useSelector((state)=>state.pharmaslice);
        const handleDynamicSelectedValueForvendorid = (e) =>{
            updateSelectedValue(formValues, setFormValues,e, 
                'vendorname', e.target.value==0?'Select Item':designvendorList.find(obj => obj.id === e.target.value).title);
    }

    const { apiInProgress } = useSelector((state) => state.headerslice)
    useEffect(() => {

    }, [apiInProgress])
    useEffect(() => {
        formValues.unitid.required = getUnitIdVisibility();
    },[productObj]);

    useEffect(() => {
        // Load Design Vendor List
        //getDesignVendorList(()=>{}, (data) => {dispatch(setDesignvendorList(data)); })

        if (pmorderId !== -1) {
            if (dataLoaded) return;
            getAPI(pmorderId, loadForm);
        }
        else {
            // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }
        console.log("formValues=>"+JSON.stringify(formValues));

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }, ['productid']: {
                ...formValues['productid'],
                value: productObj.id
            }, ['orderid']: {
                ...formValues['orderid'],
                value: productObj.orderid
            }, ['unitid']: {
                ...formValues['unitid'],
                required: getUnitIdVisibility(),
                value: formValues.unitid.value === 0 ? 1 : formValues.unitid.value
            }
        })
    }, []);
    
    useEffect(() => {
        if ( (formValues.availableqty.value >0 || (formValues.orderedqty.value>0)) && formValues.unitid.value===0) {
            formValues.unitid.required = true;
            formValues.unitid.error = true;
            formValues.unitid.errorMessage = 'Please select unit';
           
        }
      },[formValues.availableqty.value, formValues.orderedqty.value, formValues.unitid.value]);
    
    const getUnitIdVisibility = () => {
        if (selectedTaskObj && selectedTaskObj.taskid===60) {
            if (productObj.designstatus=='STOCK_CHECK')
            formValues.unitid.required=false
        } 
        return true;
    }
   
    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data) => {
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value + " == " + getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value)
            return "yes"
        else
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value === "yes")
            return true
        else
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) => {
        setShowError(false);

        if (validNameEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);

        if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);

        if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues, e);
    }

    const createSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(addPmorderObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForPmorder(false));
    }
    const updateSuccessCallback = (obj) => {
        dispatch(setApiInProgress(false));
        dispatch(updatePmorderObj(obj));
        setNotification('Record with id[' + pmorderId + '] has been updated successfully !!!');
        dispatch(setShowEditForPmorder(false));

    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) => {
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id, formValues, updateSuccessCallback, failuerCallback) => {
        dispatch(setApiInProgress(true));
        updateAPI(id, formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit = (e) => {
        if (formValues.unitid.required && formValues.unitid.value===0) {
            e.preventDefault();
            return;
        }
        handleSubmit(e, pmorderId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);

        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr = date.getFullYear() + "-" + monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError ? <Alert severity="error">{errorMsg}</Alert> : ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '58vh' }}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{pmorderId === -1 ? 'Add' : 'Edit'} Packaging Material Order </Typography>
                                <Divider />
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded ?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center">

                                    <Grid item lg={6} xs={12}>
                                        <TextField size="Normal"
                                            placeholder={formValues.title.placeholder}
                                            required={formValues.title.required}
                                            label={formValues.title.label}
                                            name={formValues.title.name}
                                            value={formValues.title.value}
                                            onChange={handleTextChange}
                                            error={formValues.title.error}
                                            helperText={formValues.title.error && formValues.title.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                     
                                            
                                    
                                    <Grid item lg={2} xs={6} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.qty.placeholder}
                                            required={formValues.qty.required}
                                            label="Order Qty"
                                            name={formValues.qty.name}
                                            value={formValues.qty.value}
                                            onChange={handleDoubleChange}
                                            error={formValues.qty.error}
                                            helperText={formValues.qty.error && formValues.qty.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                     <Grid item lg={2} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.requiredqty.placeholder}
                                            required={formValues.requiredqty.required}
                                            label={formValues.requiredqty.label}
                                            name={formValues.requiredqty.name}
                                            value={formValues.requiredqty.value}
                                            onChange={handleDoubleChange}
                                            error={formValues.requiredqty.error}
                                            helperText={formValues.requiredqty.error && formValues.requiredqty.errorMessage}
                                            sx={{width:'100%'}}
                                            disabled={rolename==='PHARMA_OMS_STORE'?true:false}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={6} sx={{ display: selectedTaskObj.taskid===112?'inline':'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.availableqty.placeholder}
                                            required={formValues.availableqty.required}
                                            label={formValues.availableqty.label}
                                            name={formValues.availableqty.name}
                                            value={formValues.availableqty.value}
                                            onChange={handleTextChange}
                                            error={formValues.availableqty.error}
                                            helperText={formValues.availableqty.error && formValues.availableqty.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                    {/* {productObj.designstatus==='ORDERED' &&               */}
                                        <Grid item lg={4} xs={12} sx={{ display: productObj.designstatus==='ORDERED'?'inline':'none' }}>
                                            <TextField size="Normal"
                                                placeholder={formValues.orderedqty.placeholder}
                                                required={formValues.orderedqty.required}
                                                label={formValues.orderedqty.label}
                                                name={formValues.orderedqty.name}
                                                value={formValues.orderedqty.value}
                                                onChange={handleDoubleChange}
                                                error={formValues.orderedqty.error}
                                                helperText={formValues.orderedqty.error && formValues.orderedqty.errorMessage}
                                                sx={{width:'100%'}}
                                            />
                                        </Grid>
                                       {/* } */}

                                    <Grid item lg={2} xs={12} sx={{ display: formValues.unitid.required?'inline':'none' }}>
                                        <FormControl sx={{ width: '100%' }} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.unitid.label}</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-autowidth-label"
                                                id="demo-simple-select-autowidth"
                                                label={formValues.unitid.label}
                                                name={formValues.unitid.name}
                                                value={formValues.unitid.value}
                                                onChange={handleDynamicSelectedValueForunitid}

                                                error={formValues.unitid.error}
                                                helpertext={formValues.unitid.error && formValues.unitid.errorMessage}
                                            >
                                                <MenuItem key={0} value="0">Select Unit</MenuItem>
                                                {
                                                    dmunitList && dmunitList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>)
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item lg={3} xs={12} sx={{ display:'none' }}>
                                        <FormControl sx={{  width:'100%'}} size="Normal">
                                            <InputLabel id="demo-simple-select-autowidth-label">{formValues.vendorid.label}</InputLabel>
                                            <Select
                                                    labelId="demo-simple-select-autowidth-label"
                                                    id="demo-simple-select-autowidth"
                                                    label={formValues.vendorid.label}
                                                    name={formValues.vendorid.name}
                                                    value={formValues.vendorid.value}
                                                    onChange={handleDynamicSelectedValueForvendorid}
                                                    
                                                    error={formValues.vendorid.error}
                                                    helpertext={formValues.vendorid.error && formValues.vendorid.errorMessage}
                                                    >
                                                    <MenuItem key={0} value="0">Select Item</MenuItem>
                                                    {
                                                        designvendorList && designvendorList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                                    }
                                                </Select>
                                        </FormControl> 
                                    </Grid>                        
                                    <Grid item lg={6} xs={12} sx={{display:selectedTaskObj.taskid===112 || productObj.designstatus==='STOCK_CHECK'?'none':'inline'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.vendorname.placeholder}
                                            required={formValues.vendorname.required}
                                            label={formValues.vendorname.label}
                                            name={formValues.vendorname.name}
                                            value={formValues.vendorname.value}
                                            onChange={handleTextChange}
                                            error={formValues.vendorname.error}
                                            helperText={formValues.vendorname.error && formValues.vendorname.errorMessage}
                                            sx={{width:'100%'}}
                                        />
                                    </Grid>
                                    <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                        <MyDate
                                            label={formValues.receivedon.label}
                                            fieldName={formValues.receivedon.name}
                                            defaultValue={formValues.receivedon.value}
                                            errStr={formValues.receivedon.errorMessage}
                                            setDate={setDate}
                                        />
                                    </Grid>
                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.productid.placeholder}
                                            required={formValues.productid.required}
                                            label={formValues.productid.label}
                                            name={formValues.productid.name}
                                            value={formValues.productid.value}
                                            onChange={handleTextChange}
                                            error={formValues.productid.error}
                                            helperText={formValues.productid.error && formValues.productid.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.orderid.placeholder}
                                            required={formValues.orderid.required}
                                            label={formValues.orderid.label}
                                            name={formValues.orderid.name}
                                            value={formValues.orderid.value}
                                            onChange={handleTextChange}
                                            error={formValues.orderid.error}
                                            helperText={formValues.orderid.error && formValues.orderid.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.pmstatus.placeholder}
                                            required={formValues.pmstatus.required}
                                            label={formValues.pmstatus.label}
                                            name={formValues.pmstatus.name}
                                            value={formValues.pmstatus.value}
                                            onChange={handleTextChange}
                                            error={formValues.pmstatus.error}
                                            helperText={formValues.pmstatus.error && formValues.pmstatus.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>
                                    <Grid item lg={3} xs={12} sx={{ display: 'none' }}>
                                        <MyDate
                                            label={formValues.orderdate.label}
                                            fieldName={formValues.orderdate.name}
                                            defaultValue={formValues.orderdate.value}
                                            errStr={formValues.orderdate.errorMessage}
                                            setDate={setDate}
                                        />
                                    </Grid>


                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.unitname.placeholder}
                                            required={formValues.unitname.required}
                                            label={formValues.unitname.label}
                                            name={formValues.unitname.name}
                                            value={formValues.unitname.value}
                                            onChange={handleTextChange}
                                            error={formValues.unitname.error}
                                            helperText={formValues.unitname.error && formValues.unitname.errorMessage}
                                            sx={{ width: '100%' }}
                                        />
                                    </Grid>

                                    <Grid item lg={4} xs={12} sx={{ display: 'none' }}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%', }}
                                        />
                                    </Grid>
                                </Grid>
                                : <></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider />
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                    {apiInProgress ? <CircularProgress /> :
                        <>
                            <Button variant="outlined" type="submit" >{pmorderId === -1 ? 'Add' : 'Save'}</Button>&nbsp;&nbsp;&nbsp;
                            <Button variant="outlined" onClick={() => { dispatch(setShowEditForPmorder(false)); }}>Close</Button>
                        </>
                    }
                </Grid>
            </Grid>
        </form>
    );
};